import React from 'react'
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { PaymentRequest } from '@stripe/stripe-js'
import { When } from 'react-if'
import { PayPalPayment } from '@/molecules/PayPalPayment'
import { Offer } from '@/services/PifService'
import { isSupportedPayPalCurrency, isSupportedStripeCurrency } from '@/services/PifService/PifService'
import { getPriceForCurrency } from '@/services/PriceFormatter'
import { getDecimalsForCurrency } from '@/services/PriceFormatter/PriceFormatter'
import { useUser } from '@/services/UserService'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { OrderCompleteArgs } from '@/views/PayItForward/PayItForwardProjectCheckoutOfferView/PayItForwardStripeForm/usePayItForwardForm/PayItForwardFormContext'

interface ExpressCheckoutMethodsProps {
  walletPaymentRequest: PaymentRequest | null
  enablePaypal: boolean
  projectSlug: string
  onPayItForwardComplete: (args: OrderCompleteArgs) => void
  offer: Offer
  name: string
  disableOrSection: boolean
}

const OrSection: React.FC<{ disableOrSection: boolean }> = ({ disableOrSection }) => {
  const { t } = useTranslate('pif')
  if (disableOrSection) return <></>
  return (
    <div className="flex flex-row items-center">
      <div className="h-0.5 grow-1 bg-gray-300" />
      <div className="p-3 uppercase text-gray-600">
        <Translate t={t} i18nKey="or">
          or
        </Translate>
      </div>
      <div className="h-0.5 grow-1 bg-gray-300" />
    </div>
  )
}

export const ExpressCheckoutMethods: React.FC<ExpressCheckoutMethodsProps> = ({
  walletPaymentRequest,
  enablePaypal,
  projectSlug,
  onPayItForwardComplete,
  offer,
  name,
  disableOrSection,
}) => {
  const { user } = useUser()
  const isGuest = !user
  return (
    <>
      {enablePaypal && (
        <>
          {<OrSection disableOrSection={disableOrSection} />}
          <When condition={isSupportedPayPalCurrency(offer.currency)}>
            <PayPalPayment
              name={projectSlug}
              onComplete={onPayItForwardComplete}
              description={`Angel Studios: ${projectSlug}:pif`}
              softDescriptor={`${projectSlug || 'Pay it Forward'}`}
              sku={offer?.slug || name}
              currency={offer.currency.toUpperCase()}
              amount={getPriceForCurrency(offer.price, offer.currency).toFixed(getDecimalsForCurrency(offer.currency))}
              buttonHeight={50}
              isGuest={isGuest}
            />
          </When>
        </>
      )}
      {walletPaymentRequest && (
        <When condition={isSupportedStripeCurrency(offer.currency)}>
          {!enablePaypal && <OrSection disableOrSection={disableOrSection} />}
          <div className="h-50 mb-[7px] mt-1 rounded">
            <PaymentRequestButtonElement
              options={{ paymentRequest: walletPaymentRequest, style: { paymentRequestButton: { height: '50px' } } }}
            />
          </div>
        </When>
      )}
    </>
  )
}
